import React, { memo, useReducer, useState } from 'react';
import { AdvanceFilter, Button, Table, Text } from 'components/src';
import {
  routesName,
  useDateChange,
  useGetAuthorityFindRoles,
  useNavigation,
} from 'core';
import { useTranslation } from 'react-i18next';
import { Flex, Space, TablePaginationConfig } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { CiEdit } from 'react-icons/ci';
import { PiNotebookLight } from 'react-icons/pi';
import {
  handleFiltering,
  initialState,
  reducer,
  updateCurrentPage,
} from './store';

interface Props {}

const RolesList = memo<Props>(() => {
  const { _navigate, _navigateWithParams } = useNavigation();
  const { i18n } = useTranslation();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>(
    []
  );
  const { changeDateToPersian } = useDateChange();
  const [
    { currentPage, filters, dropdown, id, showModal, advanceFilter },
    dispatch,
  ] = useReducer(reducer, initialState);
  const { data, isFetching } = useGetAuthorityFindRoles({
    pageNumber: currentPage,
    pageSize: '10',
    roleName: advanceFilter.title,
  });

  const columns: any = [
    {
      title: i18n.t('id'),
      key: 'id',
      dataIndex: 'id',

      render: (text: any) => <Text>{text}</Text>,
    },
    {
      title: i18n.t('name'),
      dataIndex: 'name',
      key: 'name',
      render: (text: any) => <Text>{text}</Text>,
    },
    {
      title: i18n.t('created_at'),
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text: any) => <Text>{changeDateToPersian(text)}</Text>,
    },
    {
      title: i18n.t('updated_at'),
      dataIndex: 'updated_at',
      key: 'updated_at',
      render: (text: any) => <Text>{changeDateToPersian(text)}</Text>,
    },
    {
      title: i18n.t('permissions'),
      dataIndex: 'permissions',
      key: 'permissions',
      render: (text: any) =>
        text.map((item: any) => {
          return <Text>{item.name}-</Text>;
        }),
    },
    {
      title: i18n.t('operation'),
      key: 'operation',
      dataIndex: 'operation',
      render: (_: any, record: any) => (
        <Flex align="center" justify="start">
          <Space>
            <Button
              title={i18n.t('details')}
              customColor="warning"
              onClick={() => {
                _navigateWithParams(routesName.ROLEDETAIL, {
                  id: record.id,
                });
              }}
            >
              <PiNotebookLight size={20} />
            </Button>
            <Button
              title={i18n.t('edit')}
              onClick={() => {
                _navigateWithParams(routesName.EDITROLE, {
                  id: record.id,
                });
              }}
            >
              <CiEdit size={20} />
            </Button>
          </Space>
        </Flex>
      ),
    },
  ];

  const onAdvanceFilterChange = (filterValues: any) => {
    dispatch(handleFiltering(filterValues));
  };

  const handlePageChange = (current_page: number) => {
    dispatch(updateCurrentPage(current_page));
  };

  const pagination: TablePaginationConfig = {
    current: data?.meta?.current_page,
    pageSize: 10,
    total: data?.data?.totalCount,
    onChange: handlePageChange,
    showSizeChanger: false,
    position: ['bottomRight'],
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const isLoading = isFetching;
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <>
      <Button
        type="primary"
        onClick={() => {
          _navigate(routesName.ADDROLE);
        }}
      >
        <PlusOutlined />
        {i18n.t('addRole')}
      </Button>
      <Table
        rowSelection={rowSelection}
        filterComponent={
          <AdvanceFilter
            setAdvanceFilter={onAdvanceFilterChange}
            titleField={true}
          />
        }
        loading={isLoading}
        // excelIcon={
        //   <Button
        //     title={i18n.t('downloadCampaigns')}
        //     isLoading={isCampaignNumberStatisticLoading}
        //     onClick={handleDownload}
        //   >
        //     <RiFileExcel2Line
        //       size={25}
        //       color={colors.green01}
        //       onClick={handleDownload}
        //       title={i18n.t('stats')}
        //     />
        //   </Button>
        // }
        {...{ columns }}
        dataSource={data?.data?.roles}
        pagination={pagination}
      ></Table>
    </>
  );
});
export { RolesList };
